import React, { useContext, useEffect, useState } from "react";
import swinkpay_logo from "../assets/swinklogo.png";
import pci from "../assets/pci.png";
import DataContext from "../contexts/DataProvider";
import { FaLock } from "react-icons/fa";

export default function Page404() {
  const [finishStatus, setfinishStatus] = useState(false);
  const [vw, setVw] = useState(window.innerWidth);
  const [vh, setVh] = useState(window.innerHeight);
  const { data } = useContext(DataContext);

  useEffect(() => {
    const handler = () => { setVw(window.innerWidth); setVh(window.innerHeight); };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div className="payment-page-bg" style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden' }}>

      <div style={vw >= 640 ? {
        position: 'fixed',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: Math.min(Math.max(420, vw * 0.42), vw - 24),
        height: Math.min(780, vh - 24),
        borderRadius: 16, overflow: 'hidden',
        display: 'flex', flexDirection: 'column', zIndex: 10,
      } : {
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex', flexDirection: 'column', zIndex: 10,
      }}>

        {/* Header (white) */}
        <div className="flex-none flex items-center px-4 py-3 bg-white border-b border-gray-100">
          <div className="flex items-center gap-1.5 text-gray-500 text-[10px] font-medium">
            <FaLock style={{ fontSize: 10, color: "#1E56C8" }} />
            <span>Secure Payment</span>
          </div>
        </div>

        {/* Body */}
        <div
          className="flex-grow flex flex-col items-center justify-center px-5 py-5 overflow-y-auto"
          style={{ background: "#eef2f7" }}
        >
          {/* White card */}
          <div
            className="w-full bg-white rounded-2xl overflow-hidden"
            style={{
              boxShadow: "0 8px 32px rgba(15,74,138,0.13), 0 2px 8px rgba(0,0,0,0.06)",
              animation: "card-slide-up 0.55s cubic-bezier(0.34,1.56,0.64,1) both",
            }}
          >
            {/* 404 section */}
            <div className="flex flex-col items-center pt-8 pb-2 px-6">

              {/* Large 404 */}
              <div style={{ animation: "fade-up 0.5s 0.15s ease both", lineHeight: 1 }}>
                <span style={{
                  fontSize: "clamp(80px,24vw,108px)",
                  fontWeight: 900,
                  letterSpacing: -5,
                  lineHeight: 1,
                  background: "linear-gradient(160deg, #062a5a 0%, #0f4a8a 45%, #1565c0 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  display: "inline-block",
                }}>404</span>
              </div>

              {/* Gradient divider */}
              <div
                className="rounded-full my-3"
                style={{
                  height: 3, width: 56,
                  background: "linear-gradient(90deg, #1a6cb8, #24CB7E)",
                  animation: "expand-line 0.6s 0.35s ease both",
                }}
              />

              {/* Heading */}
              <p
                className="text-center font-black text-gray-900 uppercase mb-3"
                style={{
                  fontSize: "clamp(13px,3.8vw,16px)",
                  letterSpacing: "0.12em",
                  lineHeight: 1.4,
                  animation: "fade-up 0.5s 0.25s ease both",
                }}
              >
                Transaction Page<br />Not Found
              </p>

              {/* Description */}
              <p
                className="text-center text-gray-500 leading-relaxed mb-5"
                style={{
                  fontSize: "clamp(11px,3vw,12.5px)",
                  animation: "fade-up 0.5s 0.35s ease both",
                  maxWidth: 300,
                }}
              >
                We cannot find the page for this specific transaction. The link you are trying to access is{" "}
                <strong className="text-gray-700 font-semibold">incorrect</strong>, or the session has{" "}
                <strong className="text-gray-700 font-semibold">expired</strong>. We recommend starting over.
              </p>
            </div>

            {/* Illustration */}
            <div
              className="flex items-center justify-center pb-8"
              style={{ animation: "fade-up 0.55s 0.45s ease both" }}
            >
              <svg width="210" height="110" viewBox="0 0 210 110" fill="none">

                {/* ── Server rack (left) ── */}
                {/* Cabinet */}
                <rect x="8" y="14" width="58" height="72" rx="5" fill="#dbeafe" stroke="#93c5fd" strokeWidth="1.2"/>
                {/* Server bays */}
                {[0,1,2,3].map((i) => (
                  <g key={i}>
                    <rect x="14" y={20 + i*16} width="46" height="12" rx="3" fill="white" stroke="#bfdbfe" strokeWidth="1"/>
                    {/* LED indicator */}
                    <circle cx="53" cy={26 + i*16} r="2.5" fill={i === 2 ? "#ef4444" : "#34d399"}/>
                    {/* Drive bars */}
                    <rect x="18" y={23 + i*16} width="22" height="6" rx="2" fill="#e0f2fe"/>
                    <rect x="42" y={24 + i*16} width="6" height="4" rx="1.5" fill="#bfdbfe"/>
                  </g>
                ))}
                {/* Base */}
                <rect x="20" y="88" width="34" height="5" rx="2.5" fill="#bfdbfe"/>
                <rect x="25" y="93" width="24" height="3" rx="1.5" fill="#93c5fd"/>

                {/* ── Broken chain link (center) ── */}
                {/* Left half of chain (intact — blue) */}
                <path d="M82 48 C82 42 88 38 93 40 L97 44" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M82 58 C82 64 88 68 93 66 L97 62" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M82 48 L82 58" stroke="#1d4ed8" strokeWidth="2.5" strokeLinecap="round"/>
                {/* Right half (broken — red) */}
                <path d="M113 44 L117 40 C122 38 128 42 128 48" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M113 62 L117 66 C122 68 128 64 128 58" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M128 48 L128 58" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"/>
                {/* Gap sparks */}
                <line x1="100" y1="51" x2="103" y2="48" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="107" y1="51" x2="110" y2="48" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="103" y1="56" x2="107" y2="52" stroke="#fbbf24" strokeWidth="1.5" strokeLinecap="round"/>

                {/* ── Connection lines ── */}
                <line x1="66" y1="53" x2="80" y2="53" stroke="#93c5fd" strokeWidth="1.5" strokeDasharray="3 2"/>
                <line x1="130" y1="53" x2="142" y2="53" stroke="#fca5a5" strokeWidth="1.5" strokeDasharray="3 2"/>

                {/* ── Robot (right) ── */}
                {/* Antenna */}
                <line x1="166" y1="14" x2="166" y2="22" stroke="#60a5fa" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="166" cy="12" r="3" fill="#3b82f6"/>
                {/* Head */}
                <rect x="148" y="22" width="36" height="28" rx="7" fill="#dbeafe" stroke="#60a5fa" strokeWidth="1.3"/>
                {/* Eyes */}
                <circle cx="159" cy="35" r="4.5" fill="white" stroke="#3b82f6" strokeWidth="1"/>
                <circle cx="173" cy="35" r="4.5" fill="white" stroke="#3b82f6" strokeWidth="1"/>
                <circle cx="159" cy="35" r="2.5" fill="#1d4ed8"/>
                <circle cx="173" cy="35" r="2.5" fill="#1d4ed8"/>
                <circle cx="160" cy="34" r="1" fill="white"/>
                <circle cx="174" cy="34" r="1" fill="white"/>
                {/* Mouth */}
                <path d="M158 44 Q166 47 174 44" stroke="#93c5fd" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
                {/* Body */}
                <rect x="150" y="52" width="32" height="26" rx="5" fill="#bfdbfe" stroke="#60a5fa" strokeWidth="1.3"/>
                {/* Chest panel */}
                <rect x="156" y="57" width="20" height="14" rx="3" fill="#dbeafe"/>
                <circle cx="161" cy="62" r="2" fill="#34d399"/>
                <circle cx="166" cy="62" r="2" fill="#fbbf24"/>
                <circle cx="171" cy="62" r="2" fill="#f87171"/>
                <rect x="158" y="66" width="16" height="3" rx="1.5" fill="#93c5fd"/>
                {/* Arms */}
                <rect x="138" y="53" width="11" height="7" rx="3.5" fill="#93c5fd" stroke="#60a5fa" strokeWidth="1"/>
                <rect x="183" y="53" width="11" height="7" rx="3.5" fill="#93c5fd" stroke="#60a5fa" strokeWidth="1"/>
                {/* Legs */}
                <rect x="154" y="78" width="9" height="14" rx="4" fill="#93c5fd" stroke="#60a5fa" strokeWidth="1"/>
                <rect x="169" y="78" width="9" height="14" rx="4" fill="#93c5fd" stroke="#60a5fa" strokeWidth="1"/>
                {/* Feet */}
                <rect x="151" y="88" width="15" height="6" rx="3" fill="#7dd3fc"/>
                <rect x="166" y="88" width="15" height="6" rx="3" fill="#7dd3fc"/>
                {/* Question mark bubble */}
                <circle cx="190" cy="22" r="11" fill="#fff7ed" stroke="#fb923c" strokeWidth="1.2"/>
                <text x="186.5" y="27" fontSize="13" fontWeight="900" fill="#ea580c">?</text>
              </svg>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex-none bg-white border-t border-gray-100 py-3 px-4">
          <div className="flex items-center justify-center gap-2">
            <FaLock className="text-[#24CB7E] text-xs" />
            <span className="text-[10px] text-gray-400 font-medium">256-bit Encrypted</span>
            <span className="text-gray-200 text-xs">|</span>
            <img src={pci} alt="pci" className="h-5 w-auto" />
            <span className="text-gray-200 text-xs">|</span>
            <img src={swinkpay_logo} alt="SwinkPay" className="h-5 w-auto" />
          </div>
        </div>

      </div>
    </div>
  );
}
